<template lang="pug">
  main
    aside
    div(class="centered")
      h1 Page not found
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>

<style>
.centered {
  display: grid;
  place-content: center;
  text-align: center;
  width: 100%;
  height: 50vh;
}
</style>
